<template>
  <div class="info-page">
    <!-- 仅原来的 section 3 内容 -->
    <div v-wechat-title="'《最强蜗牛》月光下的约定'"></div>
    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' v-on:channelCallback='selectCallback' :gameName="gameName" :game_id="39"
      :downloadUrl="downloadUrl" :loginTypes="loginTypes" channelTips="角色UID可在游戏中—设置—UID查看" :autoOpenOS="false"
      @loginSuccess="loginSuccess" @selectCallback="loginCallback" noAuthLogin></Login>
    <Os v-if='isShowOs' v-on:selectCallback='selectCallback' v-on:logoutCallback='osCancell'
      @getSelectInfo='getSelectInfo' :gameName="gameName"></Os>
    <!-- 头部 -->
    <Header v-if='true' :config='headerConfig' :isShowInfo='true' :isOnline='1' :downloadApp="downloadApp" />
    <div class="content-box">
      <div class="banner">
        <div class="jingang"><span>{{ jingangNum }}</span></div>
        <div class="xiuluo"><span>{{ xiuluoNum }}</span></div>
      </div>
      <div class="banner-box" />
      <div class="activities-box">
        <div class="activities-content">
          <div class="tabs-container" ref="tabsContainer">
            <div v-for="(tab, index) in activitiesCards" ref="tabItems" :key="index"
              :class="`tab-item tab-item-${index + 1} ${activeIndex === index ? 'active' : ''}`"
              @click="goToSlide(index)" />
          </div>
          <div class="activities-swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="card in activitiesCards" :key="card.id">
                <img :src="card.image" alt="">
              </div>
            </div>
          </div>
          <div class="btn-go" @click="enterUrl"
            :class="{ disabled: isNotStarted(activitiesCards.find((i, index) => index === activeIndex).time) }" />
          <div class="activities-swiper-button-next swiper-button-next"></div>
          <div class="activities-swiper-button-prev swiper-button-prev"></div>
          <!-- <div class="activities-swiper-pagination swiper-pagination"></div> -->
        </div>
        <div class="yutu"></div>
      </div>
      <div class="game-feature-box">
        <div class="game-feature-content">
          <div class="game-feature-title"></div>
          <div class="game-feature-swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="card in gameFeatureCards" :key="card.id">
                <img :src="card.image" alt="">
              </div>
            </div>
          </div>
          <div class="game-feature-swiper-button-next swiper-button-next"></div>
          <div class="game-feature-swiper-button-prev swiper-button-prev"></div>
          <div class="game-feature-swiper-pagination swiper-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../Header/index.vue'
import { mapState, mapMutations, mapActions } from 'vuex'
import { Toast, Indicator } from 'mint-ui'
import { headerConfig } from '../headerConfig'
import Os from '@/components/os'
import Login from '@/components/login'
import { getRandomString } from "@/utils/utils"
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { onGetInitDataAPI , onGetTimeAPI } from '../api';

export default {
  name: 'RecallInfo',
  components: {
    Header,
    swiper,
    swiperSlide,
    Login,
    Os,
  },
  props: {
    downloadApp: {
      type: Function,
      default: () => {
        return () => { }
      }
    },
    logger: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      headerConfig,
      gameName: 'snail',
      downloadUrl: 'http://snail.qingcigame.com/official/',
      loginTypes: ["sms", "password"],
      activitiesSwiper: null,
      gameFeatureSwiper: null,
      activitiesCards: [
        { label: '二创征集计划', id: 1, image: 'https://download4.qcplay.com/h5-images/active/snail/midAutumn/3/bg_activity1.png', url: 'https://l.taptap.cn/0yfi2RWJ?channel=rep-rep_pqtrmkynsl8', time: '2025-09-29 10:00:00' },
        { label: 'Tap福利活动', id: 2, image: 'https://download4.qcplay.com/h5-images/active/snail/midAutumn/3/bg_activity2.png', url: 'https://l.taptap.cn/w7mBrgx3?channel=rep-rep_atvmtghnaxy', time: '2025-09-19 00:00:00' },
        { label: '官网充值', id: 3, image: 'https://download4.qcplay.com/h5-images/active/snail/midAutumn/3/bg_activity3.png', url: 'https://pay.qingcigame.com/pay?gameId=39', time: '2025-09-26 05:00:00' },
      ],
      changeImageTime: '2025-09-26 00:00:00', // taptap签到活动开启
      activity2NewImage: 'https://download4.qcplay.com/h5-images/active/snail/midAutumn/3/bg_activity2_2.png', // taptap签到图路径
      activity2NewUrl: 'https://l.taptap.cn/k5dt06Fl?channel=rep-rep_wcyf7gbmyo2_h5url4911', // taptap签到图路径
      gameFeatureCards: [
        { id: 1, image: 'https://download4.qcplay.com/h5-images/active/snail/midAutumn/3/game1.png'},
        { id: 2, image: 'https://download4.qcplay.com/h5-images/active/snail/midAutumn/3/game2.png'},
        { id: 3, image: 'https://download4.qcplay.com/h5-images/active/snail/midAutumn/3/game3.png'},
        { id: 4, image: 'https://download4.qcplay.com/h5-images/active/snail/midAutumn/3/game4.png'},
        { id: 5, image: 'https://download4.qcplay.com/h5-images/active/snail/midAutumn/3/game5.png'},
        { id: 6, image: 'https://download4.qcplay.com/h5-images/active/snail/midAutumn/3/game6.png'},
        { id: 7, image: 'https://download4.qcplay.com/h5-images/active/snail/midAutumn/3/game7.png'},
      ],
      activeIndex: 0,
      videoShow: false,
      pvUrl: '',
      currentTime: '',
      jingangNum: 0,
      xiuluoNum: 0,
    }
  },
  created () {
    onGetTimeAPI().then((res) => {
      if (res.code !== 200) {
        return
      }
      this.currentTime = res.data.time
    })
  },
  watch: {
    logger: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.logger.sum('中秋_运营活动页');
        }
      }
    }
  },
  mounted () {
    this.initSwiper();
    this.initSwiperGameFeature();
    this.setShare({
      link: `https://h5.qingcigame.com/snail/midAutumn/anniversary${getRandomString()}`,
      title: '师傅，嫦娥被妖怪捉走了！',
      imgUrl: "https://download4.qcplay.com/qcgame-admin/3CZlD6IKJ0wa6jX3WFhsJPJU8KfS2C9mbp8drO0H.jpg",
      desc: '营救小队成立！蜗救嫦娥才不是为了礼品！',
    });
    this.getLoginContainer();
    this.updateActivityImages();
  },
  computed: {
    ...mapState(['userInfo', 'activeInfo', 'isShowLogin', 'isShowOs']),
  },
  methods: {
    // 初始化
    getLoginContainer () {
      onGetInitDataAPI()
        .then((response) => {
          this.jingangNum = response.data.num1 || 0
          this.xiuluoNum = response.data.num2 || 0
          return;
        })
    },
    onToast (config, duration) {
      const curConfig = {
        duration: duration || 1000,
        className: 'toasts'
      }
      if (!config) {
        console.error('缺少config参数')
        return false
      }
      if (typeof config === 'string') {
        curConfig.message = config
      }
      Toast(curConfig)
    },
    isNotStarted (time) {
      const currentTime = this.currentTime ? new Date(this.currentTime.replace(/-/g, "/")) : new Date()
      return new Date(time.replace(/-/g, "/")) > currentTime; // 如果活动时间在当前时间之后
    },
    initSwiper () {
      this.activitiesSwiper = new Swiper('.activities-swiper-container', {
        slidesPerView: 1,
        loop: true,
        autoplay: 3000,
        pagination: '.activities-swiper-pagination',
        paginationClickable: true,
        nextButton: '.activities-swiper-button-next',
        prevButton: '.activities-swiper-button-prev',
        onSlideChangeStart: (swiper) => {
          this.activeIndex = swiper.realIndex
          this.scrollToCenter(swiper.realIndex)
        }
      })
      this.activeIndex = this.activitiesSwiper.realIndex
    },
    goToSlide (targetIndex) {
      const swiper = this.activitiesSwiper;
      const currentIndex = swiper.activeIndex; // 当前 DOM 索引
      const slides = Array.from(swiper.slides); // 克隆后的所有 slide

      // 获取所有匹配的 slide 索引
      const matchingIndexes = slides
        .map((slide, i) => ({
          index: i,
          realIndex: +slide.getAttribute('data-swiper-slide-index')
        }))
        .filter(slide => slide.realIndex === targetIndex)

      // 找到与当前 slide 最接近的目标 index
      const nearest = matchingIndexes.reduce((prev, curr) => {
        return Math.abs(curr.index - currentIndex) < Math.abs(prev.index - currentIndex)
          ? curr
          : prev;
      });

      if (nearest) {
        swiper.slideTo(nearest.index, 300);
        this.activeIndex = targetIndex;
        this.scrollToCenter(targetIndex)
      }
    },
    scrollToCenter (index) {
      const container = this.$refs.tabsContainer;
      const tabItems = this.$refs.tabItems;
      const tab = tabItems[index];

      // 计算滚动的中心位置
      const tabOffsetLeft = tab.offsetLeft;
      const tabWidth = tab.offsetWidth;
      const containerWidth = container.offsetWidth;

      const scrollPosition = tabOffsetLeft - (containerWidth / 2) + (tabWidth / 2);
      container.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
    },
    // 定时替换活动的taptap签到图
    updateActivityImages() {
      const now = new Date()
      const changeTime = new Date(this.changeImageTime)
      if (now >= changeTime) {
        // 替换第2个活动项的图片与url
        this.activitiesCards[1].image = this.activity2NewImage;
        this.activitiesCards[1].url = this.activity2NewUrl;
      }
    },
    enterUrl () {
      const { label, url, time } = this.activitiesCards.find((i, index) => index === this.activeIndex) || {}
      if (this.isNotStarted(time)) return
      this.goLink(url, `中秋活动_${label}跳转`)
    },
    goLink (url, loggerName) {
      if (url === '') return
      Indicator.open();
      this.logger.sum(loggerName)
      setTimeout(() => { window.location.href = url; Indicator.close(); }, 200)
    },
    initSwiperGameFeature () {
      this.gameFeatureSwiper = new Swiper('.game-feature-swiper-container', {
        slidesPerView: 1,
        loop: true,
        autoplay: 3000,
        pagination: '.game-feature-swiper-pagination',
        paginationClickable: true,
        nextButton: '.game-feature-swiper-button-next',
        prevButton: '.game-feature-swiper-button-prev',
      })
    },
    selectCallback () {
    },
    loginSuccess () {
      console.log('登录成功')
    },
    loginCallback(response) {
      localStorage.setItem('midautumn_token', response.data.access_token)
    },
    osCancell () {
      console.log('osCancell')
    },
    getSelectInfo () {
      console.log('getSelectInfo')
    },
    logoutCallback () {
      console.log('logoutCallback')
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  },
}
</script>

<style lang="less" scoped>@import url('./index.less');</style>



// WEBPACK FOOTER //
// src/pages/snail/midAutumn/info/index.vue